import React, { useRef, useEffect, useCallback } from 'react';
import {useVT} from "virtualizedtableforantd4";
import {CustomTable} from "@src/components";

import debounce from 'lodash/debounce';

export function VirtualizedAndLazyScrollTable({ dataSource, getDataFunc, columnsData, ...props }) {
  const y = 640;
  const tableRef = useRef(null);
  const pageNumber = useRef(0);
  const pageSize = useRef(0);
  const debouncedGetDataFn = useRef(() => null);

  const getData = useCallback(async () => {
    await getDataFunc({}, pageNumber.current * 350);
    pageNumber.current += 1;
  }, [getDataFunc]);

  useEffect(() => {
    debouncedGetDataFn.current = debounce(getData, 500);
  }, [getData]);

  const [vt] = useVT(() => {
    return {
      scroll: { y },
      onScroll: ({top}) => {
        const antTableBody = tableRef.current.querySelector(".ant-table-body");
        if(antTableBody.scrollHeight - (antTableBody?.offsetHeight + top) < 150) {
          if(dataSource.length > pageSize.current){
            debouncedGetDataFn.current();
            pageSize.current = dataSource.length;
          }
        }
      },
      id: "id",
    };
  }, [dataSource]);

  useEffect(() => {
    pageNumber.current = 2;
  }, []);

  if(props?.componentsData?.body?.cell){
      vt.body.cell = props.componentsData.body.cell;
  }

  return (
      <div ref={tableRef}>
        <CustomTable
            columns={columnsData}
            dataSource={dataSource}
            pagination={false}
            components={vt}
            scroll={{y, scrollToFirstRowOnChange: true}}
            {...props}
        />
      </div>
  );
}